import { BreadcrumbCurrentLink, BreadcrumbRoot, PageHeader, PageTitle } from '@oaknorth/component-core-v2';
import { useTranslation } from '@oaknorth/util-intl';
import { ResponsivePageContainer } from '@oaknorth/util-responsive';
import { BreadcrumbLinkItem, Helmet } from '@oaknorth/util-routing';

import { ExcludedBorrowersTable } from './ExcludedBorrowersTable';

export function ExcludedBorrowersPage() {
  const { t } = useTranslation();

  const title = t`diagnostics.excludedBorrowers.heading`;
  return (
    <ResponsivePageContainer
      nav={
        <BreadcrumbRoot>
          <BreadcrumbLinkItem to="../" isHomePage>{t`diagnostics.title`}</BreadcrumbLinkItem>
          <BreadcrumbCurrentLink> {title} </BreadcrumbCurrentLink>
        </BreadcrumbRoot>
      }
    >
      <PageHeader>
        <Helmet title={title} />
        <PageTitle>{title}</PageTitle>
      </PageHeader>
      <ExcludedBorrowersTable />
    </ResponsivePageContainer>
  );
}
